import React from 'react';
import { motion } from 'framer-motion';

export default function StatCardTransition({ 
  children, 
  delay = 0,
  className = ''
}) {
  return (
    <motion.div
      initial={{ scale: 0.9, rotate: -5, opacity: 0, y: 50 }}
      animate={{ scale: 1, rotate: 0, opacity: 1, y: 0 }}
      transition={{ 
        type: "spring", 
        damping: 12, 
        stiffness: 120,
        delay: delay 
      }}
      className={`relative p-8 rounded-3xl shadow-2xl overflow-hidden ${className}`}
      style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
      }}
    >
      {children}
    </motion.div>
  );
}
